import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

export default PopoverHeader
